<template>
  <v-dialog
  v-model="dialogEdit"
   max-width="500px"
 >
   <v-card>
     <v-card-title class="title-card">
       <span class="text-h5">{{ formTitle }}</span>
     </v-card-title>

     <v-card-text>
       <v-container>
         <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.empresa.id"
                :items="getEmpresas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Empresas"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.obra.id"
                :items="getObras"
                :rules="nameRules"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.nfe"
                required
                :rules="nameRules"
                label="NFE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.data_vencimento"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de vencimento"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.valor"
                required
                label="Valor"
                outlined
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Arquivo - GOOGLE DRIVE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank" disabled>Documento não cadastrado</a>
            </v-col>
          </v-row>
        </v-form>
       </v-container>
     </v-card-text>

     <v-card-actions class="d-flex justify-space-between">
      <v-row>
        <v-col cols="6">
          <v-btn
            dark
            color="green"
            @click="receber"
          >
            Receber
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            text
            @click="closeEditItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            dark
            color="primary"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
     </v-card-actions>
   </v-card>
 </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  /* eslint-disable */
 props:{
    dialogEdit: Boolean,
    objValue: Object,
   },
  data () {
    return {
      valid:false,
      formTitle:'Editar',
      nameRules: [
          v => !!v || 'Campo requirido',
      ],
      dialog: false,
      obj: {
      descricao: '',
      nome:'',
      data_vencimento:'',
      },
    }
   },
   async created () {
    await this.getAllEmpresas();
    this.obj = this.objValue
  },
  /* eslint-disable */
  watch: {
    objValue(){
      this.obj = this.objValue
    }
  },
   methods: {
    ...mapActions('valor', ['updateValor']),
    ...mapActions('empresa', {getAllEmpresas:'getAllEmpresas'}),
    ...mapActions('entrada', ['saveEntrada']),
    save() {
    this.$refs.form.validate()
      /* eslint-disable no-console */
      if (this.valid) {
        this.updateValor(this.obj)
        this.$emit('closeEditItem')
      }
    },
    async receber() {
      if (this.valid) {
        await this.updateValor({...this.obj, isPago: true})
        await this.saveEntrada({...this.obj, active: true})
        this.$emit('closeEditItem')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    closeEditItem () {
      this.$emit('closeEditItem')
    }  
 },
  computed: {
    ...mapGetters('pessoa',['getList']),
    ...mapGetters('obra', {getObras:'getList'}),
    ...mapGetters('empresa', {getEmpresas:'getList'}),
    customObj(){
      return {
        ...this.obj,
        data_vencimento_timestamp: this.formatToDatastamp(this.obj.data_vencimento)
      }
    }
  },
}
</script>